import { FC } from "react";
import { HStack, Stack, Text } from "@chakra-ui/react";

import { RadioCheckedIcon, RadioUncheckedIcon } from "../../../../icons";

type Props = {
  title: string;
  description: string;
  isDisabled: boolean;
  isSelected: boolean;
  onClick: () => void;
};

export const PaymentDestinationItem: FC<Props> = (props) => {
  const { title, description, isDisabled, isSelected, onClick } = props;

  const titleVariant = isDisabled ? "gray" : "brand";

  const bgColor = isDisabled
    ? "gray.50"
    : isSelected
      ? "purple.25"
      : "white";
  const borderColor = isDisabled
    ? "gray.100"
    : isSelected
      ? "purple.500"
      : "gray.50";

  const radioBorderColor = isDisabled ? "gray.600" : "brand.500";
  const radioFillColor = isDisabled ? "gray.50" : "white";
  const RadioIcon = isSelected ? RadioCheckedIcon : RadioUncheckedIcon;

  return (
    <Stack
      as="button"
      onClick={onClick}
      pointerEvents={isDisabled || isSelected ? "none" : "auto"}
      spacing={0}
      pt="16px"
      pb="14px"
      px="15px"
      bg={bgColor}
      border="1px solid"
      borderColor={borderColor}
      borderRadius="16px"
    >
      <HStack spacing="10px" mb="10px">
        <RadioIcon color={radioBorderColor} fill={radioFillColor} />
        <Text fontFamily="Normalidad Medium Var" variant={titleVariant}>{title}</Text>
      </HStack>

      <Text fontSize="14px" lineHeight="16px" textAlign="left">{description}</Text>
    </Stack>
  );
};
